/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * User session
 */
export interface LakeUserSessionDto {
  id: number;
  userId: number;
  loginTime: string;
  lastActivityTime: string;
  finishTime?: string;
  finishReason: string;
  ipAddresses: string;
  accountId?: number;
}
